/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/prefer-primitives */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { HEADER_HEIGHT, SIDEBAR_WIDTH } from './constants';
export var Sidebar = function Sidebar() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Background, null), /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Image, null)));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var Background = styled.div({
  display: 'inline-block',
  position: 'fixed',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  top: "".concat(HEADER_HEIGHT, "px"),
  right: 0,
  height: '100%',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  width: "".concat(SIDEBAR_WIDTH - 2, "px"),
  background: '#fafbfc',
  borderLeft: '2px solid #dfe1e6'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var Wrapper = styled.div({
  position: 'fixed',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  top: "".concat(HEADER_HEIGHT, "px"),
  right: 0,
  borderLeft: '24px solid #fff'
});
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "333",
    height: "776",
    fill: "none"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "SidebarH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h333v776H0V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFBFC",
    d: "M0 0h333v776H0V0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "89.122",
    height: "6",
    x: "32",
    y: "40",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#SidebarA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 70h269v175H32z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    x: "44",
    y: "81",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "78",
    height: "6",
    x: "80",
    y: "90",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M265 81h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    fillRule: "evenodd",
    d: "M273.292 91.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    d: "M32 117h269v-1H32z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SidebarB)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B2D4FF",
    d: "M71.944 135.997c0-6.597-5.348-11.945-11.945-11.945s-11.945 5.348-11.945 11.945 5.348 11.945 11.945 11.945 11.945-5.348 11.945-11.945Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    d: "M65.115 145.352a3.421 3.421 0 0 1-2.124-3.16 3.338 3.338 0 0 1 1.177-2.575c4.71-3.955 1.788-11.614-4.29-11.491-5.957.102-8.666 7.619-4.044 11.491a3.344 3.344 0 0 1 1.177 2.575 3.416 3.416 0 0 1-2.124 3.16c-.37.154-.733.325-1.092.505-.1.052-.194.112-.292.165a11.882 11.882 0 0 0 6.499 1.926c2.4 0 4.633-.71 6.503-1.928a13.607 13.607 0 0 0-1.388-.668h-.002Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: "130",
    height: "6",
    x: "80",
    y: "133",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SidebarC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B2D4FF",
    d: "M72 176c0-6.627-5.373-12-12-12s-12 5.373-12 12 5.373 12 12 12 12-5.373 12-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    d: "M65.12 185.395a3.43 3.43 0 0 1-1.77-1.648l3.01.006c.719.004 1.212-.818.853-1.448a5.53 5.53 0 0 1-.622-2.561v-4.867a6.833 6.833 0 0 0-1.758-4.662c-3.493-3.825-9.956-2.25-11.202 2.838-.44 1.194-.196 5.357-.253 6.666a5.478 5.478 0 0 1-.628 2.561.983.983 0 0 0 .854 1.452l3.015.006a3.431 3.431 0 0 1-1.776 1.658c-.292.125-.586.252-.87.396-.175.084-.346.177-.515.269a11.943 11.943 0 0 0 6.544 1.943c2.407 0 4.646-.711 6.524-1.932a10.607 10.607 0 0 0-.538-.28 13.187 13.187 0 0 0-.87-.396l.003-.001Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: "130",
    height: "6",
    x: "80",
    y: "173",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M48 204h24v24H48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    fillRule: "evenodd",
    d: "M61 215v-7.007a.996.996 0 0 0-1-.993c-.556 0-1 .445-1 .993V215h-7.007a.999.999 0 0 0-.993 1c0 .557.445 1 .993 1H59v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V217h7.007a.998.998 0 0 0 .993-1c0-.556-.445-1-.993-1H61Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "90",
    height: "6",
    x: "80",
    y: "213",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#SidebarD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 261h269v174H32z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    x: "44",
    y: "272",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "114",
    height: "6",
    x: "80",
    y: "281",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F7",
    fillRule: "evenodd",
    d: "M218 292a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M265 272h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    fillRule: "evenodd",
    d: "M273.292 282.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    d: "M32 307.731h269v-.994H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F7",
    fillRule: "evenodd",
    d: "M60 335a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "170",
    height: "6",
    x: "80",
    y: "324",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F7",
    fillRule: "evenodd",
    d: "M60 375a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "139",
    height: "6",
    x: "80",
    y: "364",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M50 397h20v20H50z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36B37E",
    fillRule: "evenodd",
    d: "M68.333 407a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0Zm-10.514-.776a.833.833 0 0 1 .27.187l1.078 1.077 2.744-2.744a.847.847 0 0 1 .27-.187.846.846 0 0 1 .645-.005.838.838 0 0 1 .517.778.837.837 0 0 1-.254.593l-3.333 3.333a.834.834 0 0 1-1.179 0l-1.666-1.667a.84.84 0 0 1-.255-.592.834.834 0 0 1 1.163-.773Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "194",
    height: "6",
    x: "80",
    y: "404",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#SidebarE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 452h269v174H32z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    x: "44",
    y: "463",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "114",
    height: "6",
    x: "80",
    y: "472",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M265 463h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    fillRule: "evenodd",
    d: "M273.292 473.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    d: "M32 498.731h269v-.994H32z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "12",
    height: "12",
    x: "48",
    y: "512",
    fill: "#0052CC",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M57.207 515.793a1 1 0 0 1 0 1.414l-3.5 3.5a1 1 0 0 1-1.414 0l-1.5-1.5a1 1 0 1 1 1.414-1.414l.793.793 2.793-2.793a1 1 0 0 1 1.414 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "71",
    height: "6",
    x: "76",
    y: "515",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "12",
    height: "12",
    x: "48",
    y: "552",
    fill: "#fff",
    rx: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "10",
    height: "10",
    x: "49",
    y: "553",
    stroke: "#091E42",
    strokeOpacity: ".13",
    strokeWidth: "2",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "131",
    height: "6",
    x: "76",
    y: "555",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "12",
    height: "12",
    x: "48",
    y: "592",
    fill: "#fff",
    rx: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "10",
    height: "10",
    x: "49",
    y: "593",
    stroke: "#091E42",
    strokeOpacity: ".13",
    strokeWidth: "2",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "71",
    height: "6",
    x: "76",
    y: "595",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#SidebarF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 643h269v48H32z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    x: "44",
    y: "654",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "114",
    height: "6",
    x: "80",
    y: "663",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M265 678v-24h24v24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    fillRule: "evenodd",
    d: "M275.293 669.708a1.009 1.009 0 0 0 1.419 0l2.965-2.939c.215-.218.322-.5.322-.779s-.107-.556-.322-.769l-2.955-2.93a1.008 1.008 0 0 0-1.637.322.996.996 0 0 0 0 .762c.051.121.125.23.218.322l2.317 2.298-2.327 2.307a.99.99 0 0 0 0 1.406Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#SidebarG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 707h269v48H32z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    x: "44",
    y: "718",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "114",
    height: "6",
    x: "80",
    y: "727",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M265 742v-24h24v24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    fillRule: "evenodd",
    d: "M275.293 733.708a1.009 1.009 0 0 0 1.419 0l2.965-2.939c.215-.218.322-.5.322-.779s-.107-.556-.322-.769l-2.955-2.93a1.008 1.008 0 0 0-1.637.322.996.996 0 0 0 0 .762c.051.121.125.23.218.322l2.317 2.298-2.327 2.307a.99.99 0 0 0 0 1.406Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    d: "M2 776V0h-4v776h4Z",
    mask: "url(#SidebarH)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "SidebarA",
    width: "271",
    height: "179",
    x: "31",
    y: "68",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: ".5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_943_3604"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: ".5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_943_3604",
    result: "effect2_dropShadow_943_3604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_943_3604",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "SidebarD",
    width: "271",
    height: "178",
    x: "31",
    y: "259",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: ".5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_943_3604"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: ".5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_943_3604",
    result: "effect2_dropShadow_943_3604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_943_3604",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "SidebarE",
    width: "271",
    height: "178",
    x: "31",
    y: "450",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: ".5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_943_3604"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: ".5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_943_3604",
    result: "effect2_dropShadow_943_3604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_943_3604",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "SidebarF",
    width: "271",
    height: "52",
    x: "31",
    y: "641",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: ".5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_943_3604"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: ".5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_943_3604",
    result: "effect2_dropShadow_943_3604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_943_3604",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "SidebarG",
    width: "271",
    height: "52",
    x: "31",
    y: "705",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: ".5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_943_3604"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: ".5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_943_3604",
    result: "effect2_dropShadow_943_3604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_943_3604",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SidebarB"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48 124h24v24H48z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SidebarC"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48 164h24v24H48z"
  }))));
};